// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	// TODO: write your page related code here...
});

	